import { memo } from "react";
import { useMemo } from "react";
import useFormWatch from "@rf-hooks/useFormWatch";
import MxListButtonFilter from "./MxListButtonFilter";
import countFiltersHelper from "@rf-helper/countFilters.helper";

interface MxListButtonFilterWithHookFormProps {
  handleOpenModalFilters: () => void;
}

/**
 * @description Button to open the modal of filters
 * @warning This component is used in the list page but it can be used in other pages but this component needs react-hook-form context to work
 * @param {MxListButtonFilterWithHookFormProps} props
 * @returns {React.ReactNode}
 */
const MxListButtonFilterWithHookForm = memo(
  ({ handleOpenModalFilters }: MxListButtonFilterWithHookFormProps) => {
    const fields = useFormWatch();

    const countFilters = useMemo(() => {
      return countFiltersHelper(fields);
    }, [JSON.stringify(fields)]);

    return (
      <MxListButtonFilter
        handleOpenModalFilters={handleOpenModalFilters}
        countFilters={countFilters}
      />
    );
  }
);

export default MxListButtonFilterWithHookForm;
MxListButtonFilterWithHookForm.displayName = "MxListButtonFilterWithHookForm";
